export function pending(name) {
  return `${name}_PENDING`;
}
export function fulfilled(name) {
  return `${name}_FULFILLED`;
}
export function rejected(name) {
  return `${name}_REJECTED`;
}
